import { Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useEffect, useRef } from 'react';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import {
  useOrderedDragDrop,
  type UseOrderedDragDropOptions,
} from 'utils/useOrderedDragDrop';

import { useSidebarMode } from '../../hooks/useSidebarMode';

import styles from './cardMoveHandle.module.scss';

type CardMoveHandleProps = Pick<
  UseOrderedDragDropOptions,
  'type' | 'index' | 'onMove' | 'target'
>;

export const CardMoveHandle = ({
  index,
  type,
  onMove,
  target,
}: CardMoveHandleProps): JSX.Element | null => {
  const isDisabled = useSidebarMode() === 'visibility';
  const isDisabledRef = useRef(isDisabled);
  const rowHandle = useRef<HTMLDivElement>(null);
  const flags = useFeatureFlag(['conversation-right-sidebar-visibility']);
  isDisabledRef.current = isDisabled;
  const { isOver } = useOrderedDragDrop({
    type,
    index,
    source: rowHandle,
    target,
    preview: target,
    onMove,
    triggerSwap: 'drop',
    canDrag: () => !isDisabledRef.current,
  });

  useEffect(() => {
    target.current?.classList.toggle(styles.isOver, isOver);
  }, [isOver, target]);

  if (!flags.conversationRightSidebarVisibility) {
    return null;
  }

  return (
    <div
      ref={rowHandle}
      className={classnames(styles.handle, { [styles.disabled]: isDisabled })}
    >
      <Icon name="bars" />
    </div>
  );
};
